export default {
    set_events(state, {events}) {
      state.events = events;
    },
  };
  